import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';

import { workSubTaskAddAPI, workSubTaskUpdateAPI } from '@/api/pm/projectTask';
import XhUser from '@/components/CreateCom/XhUser';
import { workWorkOwnerListAPI } from '@/api/pm/project';

import { mapGetters } from 'vuex';

export default {
  components: {
    XhUser: XhUser
  },
  props: {
    taskData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 子任务输入内容
    text: String,
    time: [String, Number],
    subData: Object,
    subTaskCom: {
      type: String,
      default: ''
    },
    taskId: [Number, String],
    checkboxData: {
      type: Boolean,
      default: false
    },
    checkDisabled: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      // 子任务选择时间
      subtasksDate: '',
      checked: false,
      // 子任务数据
      xhUserData: [],
      // 子任务人员
      isRequesting: false, // 是请求中
      subtasksTextarea: '',
      showUserPopover: false
    };
  },

  computed: _extends({
    ownerListRequest: function ownerListRequest() {
      return this.workId ? workWorkOwnerListAPI : null;
    },
    ownerListParams: function ownerListParams() {
      return this.workId ? { work_id: this.workId } : null;
    },
    workId: function workId() {
      return this.taskData ? this.taskData.work_id : '';
    },
    isChangeUser: function isChangeUser() {
      var oldUserData = this.subData.mainUser ? [this.subData.mainUser] : [];
      if (this.xhUserData.length != oldUserData.length) {
        return true;
      }

      if (this.xhUserData.length) {
        if (this.xhUserData[0].id != this.subData.mainUser.id) {
          return true;
        }
      }

      return false;
    }
  }, mapGetters(['userInfo'])),
  watch: {
    checkboxData: {
      handler: function handler(val) {
        this.checked = val;
      },

      immediate: true
    }
  },
  created: function created() {
    if (this.subTaskCom == 'edit') {
      this.subtasksTextarea = this.text ? this.text : '';
      this.subtasksDate = this.time;
      if (_JSON$stringify(this.subData) !== '{}') {
        if (this.subData.mainUser || this.subData.main_user_id) {
          this.xhUserData = this.subData.mainUser ? [this.subData.mainUser] : [this.subData];
        }
      } else {
        this.xhUserData = [];
      }
    }
  },

  methods: {
    subtasksSubmit: function subtasksSubmit(event) {
      var _this = this;

      this.subtasksTextarea = this.subtasksTextarea.split(/[\n]/).join('');
      if (this.$listeners.add) {
        if (this.subtasksTextarea) {
          this.$emit('add', {
            checked: this.checked,
            name: this.subtasksTextarea,
            stop_time: this.subtasksDate,
            mainUser: this.xhUserData.length != 0 ? this.xhUserData[0] : null
          });
        }
        this.$emit('close');
      } else {
        if (this.subtasksTextarea && !this.isRequesting) {
          this.isRequesting = true;
          if (this.subTaskCom == 'new') {
            // this.$emit('on-handle', { type: 'add', result: 'success' })
            workSubTaskAddAPI({
              pid: this.taskData.task_id,
              name: this.subtasksTextarea,
              stop_time: this.subtasksDate,
              main_user_id: this.xhUserData.length != 0 ? this.xhUserData[0].id : ''
            }).then(function (res) {
              _this.taskData.subTaskList.push({
                name: _this.subtasksTextarea,
                stop_time: _this.subtasksDate,
                task_id: res.data,
                mainUser: _this.xhUserData.length > 0 ? _this.xhUserData[0] : _this.userInfo
              });
              _this.$message.success('子任务创建成功');
              // 创建成功 -- 清除选择
              _this.subtasksTextarea = '';
              _this.subtasksDate = '';
              _this.isRequesting = false;
              _this.$emit('on-handle', { type: 'add', result: 'success' });
            }).catch(function () {
              _this.$emit('on-handle', { type: 'add', result: 'error' });
              _this.$message.error('子任务创建失败');
              _this.isRequesting = true;
            });
          } else if (this.subTaskCom == 'edit') {
            if (this.isChangeUser == 1 || this.text != this.subtasksTextarea || this.subtasksDate != this.time) {
              // this.$emit('on-handle', { type: 'edit', result: 'success' })
              workSubTaskUpdateAPI({
                task_id: this.taskId,
                stop_time: this.subtasksDate,
                main_user_id: this.xhUserData.length > 0 ? this.xhUserData[0].id || this.xhUserData[0].main_user_id : '',
                name: this.subtasksTextarea
              }).then(function (res) {
                var dataList = _this.taskData.subTaskList;
                for (var i in dataList) {
                  if (dataList[i].task_id == _this.taskId) {
                    var list = dataList[i];
                    list.name = _this.subtasksTextarea;
                    list.stop_time = _this.subtasksDate;
                    list.mainUser = _this.xhUserData.length > 0 ? _this.xhUserData[0] : null;
                    dataList.splice(i, 1, list);
                    break;
                  }
                }
                _this.isRequesting = false;
                _this.$emit('on-handle', { type: 'edit', result: 'success' });
                _this.$message.success('子任务编辑成功');
              }).catch(function () {
                _this.$emit('on-handle', { type: 'edit', result: 'error' });
                _this.$message.error('子任务编辑失败');
                _this.isRequesting = false;
              });
            } else {
              this.$emit('on-handle', { type: 'cancel' });
            }
          }
        } else {
          this.$emit('on-handle', { type: 'cancel' });
        }
      }
    },
    xhUserCheckout: function xhUserCheckout(data) {
      this.xhUserData = data;
      this.showUserPopover = false;
    },

    // 子任务 -- 时间弹框
    subtasksDateFun: function subtasksDateFun() {
      this.$refs.subtasksDate.change();
    }
  }
};